import React from 'react';

import StorageImage from 'rebook/apps/utils/components/StorageImage';


const CroppedImage = (props) => (
  <StorageImage type="cropped" {...props} />
);

export default CroppedImage;
